<template>
  <!-- 配置模板 -->
  <a-breadcrumb>
    <a-breadcrumb-item>配置管理</a-breadcrumb-item>
    <a-breadcrumb-item>界面语种管理</a-breadcrumb-item>
  </a-breadcrumb>
  <div class="content">
    <div class="action">
      <div style="flex: 1;"></div>
      <a-button type="primary" @click="add"><plus-outlined />新增语种</a-button>
    </div>
    <div class="table-box">
      <a-table
        :data-source="dataSource"
        :columns="columns"
        :pagination="pagination"
        :row-key="record => record.id"
        :loading="isLoading"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, record }">
          <!-- 前台状态 -->
          <template v-if="column.key === 'app_status'">
            <a-switch
              v-model:checked="record.app_status"
              checked-children="开"
              un-checked-children="关"
              @change="statusChange($event, record)"
            />
          </template>
          <!-- 操作 -->
          <template v-if="column.key === 'operation'">
            <a class="operation-item" @click="edit(record)">编辑</a>
            <a class="operation-item" @click="move(record, 'up')">上移</a>
            <a class="operation-item" @click="move(record, 'down')">下移</a>
          </template>
        </template>
      </a-table>
    </div>
  </div>
  <!-- 新增、编辑弹窗 -->
  <Add ref="RefAdd" @success="getList" />
</template>

<script setup>
import { ref, reactive, nextTick, onBeforeMount } from 'vue'
import { message } from 'ant-design-vue'
import Add from './components-languages/Add.vue'
import { langList, langSort, langAppStatus } from '@/api/admin'

// 单个子组件暴露体初始化
let RefAdd = ref(null)
// 数据源
let dataSource = ref(null)
// 加载
let isLoading = ref(false)
// 表头
let columns = reactive([
  {
    title: '顺序',
    dataIndex: 'sort',
    key: 'sort',
  },
  {
    title: '界面语种',
    dataIndex: 'lang_name',
    key: 'lang_name'
  },
  {
    title: '语种ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '前台名称',
    dataIndex: 'app_name',
    key: 'app_name'
  },
  {
    title: '前台状态',
    dataIndex: 'app_status',
    key: 'app_status'
  },
  {
    title: '创建日期',
    dataIndex: 'created_date',
    key: 'created_date'
  },
  {
    title: '语言值',
    dataIndex: 'value',
    key: 'value'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 名称编辑中
let isEdit = ref(false)
// 编辑中的数据
let editData = ref({})

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  getList()
})

// 表格change
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 请求分页数据
function getList () {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize
  }
  langList(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      const list = data.data
      list.forEach(item => {
        item.app_status = Boolean(item.app_status)
      })
      dataSource.value = list
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 子组件新增弹窗
function add () {
  RefAdd.value.showDrawer()
}

// 编辑
function edit (record) {
  RefAdd.value.showDrawer(record)
}

// 上移、下移
function move (record, type) {
  isLoading.value = true
  langSort({
    id: record.id,
    type,
  }).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      // 更新列表
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}

// 前台开关
function statusChange (e, record) {
  isLoading.value = true
  const params = {
    lang_id: record.id,
    app_status: Number(e)
  }
  langAppStatus(params).then(res => {
    const { code, data, msg } = res
    if (code === 0) {
      if (e) {
        message.success('开启成功')
      } else {
        message.success('关闭成功')
      }
    } else {
      message.error(res.message || msg)
    }
    getList()
  }).catch(() => {
    getList()
  })
}
</script>

<style lang="less" scoped>
.content {
  padding: 24px 0;
  .action {
    display: flex;
    margin-bottom: 16px;
  }
  .operation-item {
    margin-right: 8px;
  }
}

</style>